import { CdkPortalOutletAttachedRef, Portal } from '@angular/cdk/portal';
import { Component, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Input, TemplateRef, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ToolbarSettings } from '@m4u-angular/base/classes/BaseClasses';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { EnumPageDisplayModes, EnumPageEntitySources, EnumWindowSizes } from '@m4u-angular/core/framework/sysenums.enum';
import { PageLayoutComponent } from '@m4u-angular/ui/layouts/layout/page-layout/pagelayout.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    providers: ServiceBagServices,
    selector: 'app-bottom-sheet-dialog',
    templateUrl: './bottom-sheet-dialog.component.html',
    styleUrls: ['./bottom-sheet-dialog.component.scss']
})
export class BottomSheetDialogComponent extends BasePageComponent<BaseEntity, BaseState> {

    @ViewChild('bottomSheetContent', { read: ViewContainerRef }) containerRef: ViewContainerRef;

    @Input() ContentPortal: Portal<any>;
    @Input() ContentParams: any;
    @Input() Title: string;
    @Input() Height: EnumWindowSizes;
    @Input() Class: string;

    @ViewChild('page') pageLayout: PageLayoutComponent;

    constructor(A: ServiceBagService,
        private deviceDetector: DeviceDetectorService) {
        super(A, 'BottomSheetDialogComponent', BaseEntity, BaseState, EnumPageDisplayModes.BottomSheet, EnumPageEntitySources.External);
    }

    protected override OnInitTitle(): string {
        return this.Title;
    }

    Repaint() {
        setTimeout(() => this.pageLayout?.popup?.instance?.repaint(), 200);
    }

    ContentAttached(ref: CdkPortalOutletAttachedRef) {
        (ref as any).context = {
            $implicit: this
        };
        if (this.ContentParams && ref instanceof ComponentRef) {
            Object.entries(this.ContentParams).forEach(([key, value]) => {
                ref.instance[key] = value;
            });
        }

        if (this.deviceDetector.device === 'iPhone') this.Repaint();
    }

}
